import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TimeOccurrenceModel } from "services/models/corporate/timeOccurrence.model";
import { guidEmpty, isOvertimeOccurrenceWithoutBonusReasonId } from "utils/helps";
import { TimeBonusReasonModel } from "services/models/corporate/timeBonusReason.model";


@Component({
  selector: 'app-pre-handling-info-modal',
  templateUrl: './pre-handling-info-modal.component.html',
  styleUrls: ['./pre-handling-info-modal.component.scss']
})
export class PreHandlingInfoModalComponent implements OnInit {

  @Input() employeeId: string;
  @Input() title!: string;
  @Input() content!: string;
  @Input() item!: TimeOccurrenceModel;
  @Input() usesOvertimeJustification = false;
  @Output() closeDrawerEvent = new EventEmitter<void>();

  absenceItens: TimeOccurrenceModel[] = [];
  tempSelectedBonusReasonId: string;
  notAuthorizedItem = { id: guidEmpty, title: "NÃO" };

  get bonusReasonRadioOptions(): TimeBonusReasonModel[] {
    const allowed = this.item?.allowedBonusReasons ?? [];
    if (this.item?.subType === "OVERTIME" && this.usesOvertimeJustification) {
      return [this.notAuthorizedItem as TimeBonusReasonModel, ...allowed];
    }
    return allowed;
  }

  bonusReasonDescriptionTooltip(description: string | undefined | null): string | null {
    const trimmed = description?.trim();
    return trimmed ? trimmed : null;
  }

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    const id = this.item?.bonusReasonId;
    if (id != null && id !== "") {
      this.tempSelectedBonusReasonId = id;
    }
  }

  close(): void {
    this.activeModal.dismiss();
  }

  confirm(): void {
    this.activeModal.close();
  }

  getSelectedBonusReasonTitle(timeOccurrence: TimeOccurrenceModel): string {
    const selected = timeOccurrence.allowedBonusReasons?.find(
      (x) => x.id === timeOccurrence.bonusReasonId
    );
    if (selected) {
      return selected.title;
    }
    if (isOvertimeOccurrenceWithoutBonusReasonId(this.usesOvertimeJustification, timeOccurrence)) {
      return this.getAuthorizedLabel(timeOccurrence.authorized);
    }
    return "";
  }

  private getAuthorizedLabel(authorized: boolean | undefined): string {
    return authorized == null ? "" : authorized ? "SIM" : "NÃO";
  }

  onBonusReasonChange(selectedValue: string, absenceItem: TimeOccurrenceModel) {
    const item = this.getBonusReason(absenceItem, selectedValue);
    const foundItem = this.absenceItens.find((x) => x.id === absenceItem.id);

    if (foundItem) {
      foundItem.bonusReasonId = item ? item.id : "";
    }
  }

  getBonusReason(timeOccurrence: TimeOccurrenceModel, bonusReasonId: string) {
    return timeOccurrence.allowedBonusReasons.find(
      (x) => x.id === bonusReasonId
    );
  }

  selectBonusReason(bonusReasonId: string, item: TimeOccurrenceModel) {
    item.bonusReasonId = bonusReasonId;
    this.onBonusReasonChange(bonusReasonId, item);
  }

  selectAuthorizeOption(value: boolean, item: TimeOccurrenceModel): void {
    item.authorized = value;
  }

  open(item: TimeOccurrenceModel) {
    this.tempSelectedBonusReasonId = item.bonusReasonId;
  }

  confirmBonusReasonSelection(item: TimeOccurrenceModel): void {
    if (item.subType === "OVERTIME" && this.usesOvertimeJustification) {
      const selectedValue = this.tempSelectedBonusReasonId;
      const bonusReason = this.getBonusReason(item, selectedValue);
      item.bonusReasonId =
        selectedValue === guidEmpty ? guidEmpty : bonusReason ? bonusReason.id : "";
      item.authorized = selectedValue != null && selectedValue !== guidEmpty;
    } else {
      this.selectBonusReason(this.tempSelectedBonusReasonId, item);
    }
    this.close();
  }


}
